<template>
  <div class="page-content">
    <page-template
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
      :addColumns="addColumns"
      :editColumns="addColumns"
    ></page-template>
    <add-form ref="addFormOptions" @submit="upgradePwd"></add-form>
  </div>
</template>
<script>
  import pageTemplate from "@/components/template/pageTemplate";
  import addForm from "@/components/template/add";
  import api from "@/config/api";
  import userPower from "@/mixin/userPower";


  export default {
    mixins: [userPower],
    components: {
      addForm,
      pageTemplate,

    },
    data() {
      return {
        dialogVisibility: false,

        // 高级搜索条件
        searchOptions: {
          simple: [
            {
              label: "门店名称",
              type: "select",
              prop: "storeId",
              span: 12,
              data: [],
              isHasAll: true,
              isHasAllShop: true,//添加‘全部门店’字段
              url: api.store.store,
            },
            {
              label: "登录名",
              prop: "loginName",
              type: "input",
              ifFuzzy: true,
              placeholder: "请输入登录名",
            },
          ],
        },
        // 更多功能
        toolConfig: [
          {
            label: "添加",
            code: "insert",
          },
          {
            label: "删除",
            code: "delete",
            type: this.$utils.buttonType.tableOperate,
          },
          {
            label: "编辑",
            code: "update",
            type: this.$utils.buttonType.tableOperate,
          },
          {
            label: "修改密码",
            code: "updatePassword",
            callback: this.updatePassword
          },
        ],
        // 表格信息配置
        tableOptions: {
          indexShow: true,//是否显示索引
          columns: [
            {
              label: "门店名称",
              prop: "storeName",
              width: "120",
              align: "center",
            },
            {
              label: "姓名",
              prop: "name",
              width: "120",
              align: "center",
            },
            {
              label: "登录名",
              prop: "loginName",
              width: "120",
              align: "center"
            },
            {
              label: "手机号",
              prop: "phone",
              width: "120",
              align: "center",
              merge: true
            },
            {
              label: "角色",
              type: "select",
              prop: "roleName",
              span: 12
            },
            // {label: "邮箱", prop: "email", width: "180", align: "center"},
            // {
            //   label: "性别",
            //   prop: "gender",
            //   width: "90",
            //   align: "center",
            //   enumData: this.$utils.getCacheStatus("sysUser.gender")
            // },
          ],
          url: api.system.otherUser
        },
        // 添加字段
        addColumns: {
          labelWidth: "120px",
          span: 12,
          columns: [
            {
              label: "员工姓名",
              type: "input",
              prop: "name",
              rule: [
                {required: true, message: "请输入用户名", trigger: "blur"},
                {
                  min: 2,
                  max: 15,
                  message: "长度在 2 到 15 个字符",
                  trigger: "blur"
                }
              ]
            },
            {
              label: "工号",
              type: "code",
              prop: "loginName",
              isButtonShow: false,
              tipsInfo: '登录账号重复请重新输入！',
              checkUrl: api.system.account + "/check/login/name",
              rule: [
                {required: true, message: "请输入登陆账号", trigger: "blur"},
                {
                  min: 2,
                  max: 15,
                  message: "长度在 2 到 15 个字符",
                  trigger: "blur",
                },
              ],
            },
            {
              label: "登录密码",
              type: "password",
              prop: "password",
              isShow: false,
              defaultValue: this.$utils.md5('123456')
            },
            {
              label: '手机号',
              type: 'input',
              prop: 'phone',
              placeholder: "请输入手机号",
              maxLength: 11,
              rule: [
                {required: true, message: '请输入手机号', trigger: 'blur'},
                {pattern: this.$utils.reg.phone, message: '请输入正确的手机号', trigger: 'blur'}
              ]
            },
            {
              label: "门店名称",
              type: "select",
              prop: "storeId",
              data: [],
              isHasAll: true,
              url: api.system.seStore,
              change: this.storeChange,
              rule: [
                {required: true, message: "请选择门店", trigger: "blur"},
              ],
            },
            {
              label: "角色",
              type: "select",
              prop: "roleId",
              span: 12,
              data: [],
              //url: api.system.roleOther,
              rule: [
                {required: true, message: "请选择角色", trigger: "blur"},
              ],
            },
            // {
            //   label: "邮箱",
            //   type: "code",
            //   prop: "email",
            //   isButtonShow: false,
            //   tipsInfo: '手机号重复请重新输入！',
            //   checkUrl: api.system.account + "/verify/email",
            //   maxLength: 11,
            //   rule: [
            //     {required: true, message: "请输入手机号", trigger: "blur"},
            //     {pattern: this.$utils.reg.phone, message: "请输入正确的手机号", trigger: 'blur'}
            //   ],
            // },
            // {
            //   label: "籍贯",
            //   type: "input",
            //   prop: "nativePlace",
            // },
            // {
            //   label: "性别",
            //   type: "select",
            //   prop: "gender",
            //   data: this.$utils.getCacheStatus("sysUser.gender"),
            //   rule: [
            //     {required: true, message: "请选择性别", trigger: "blur"},
            //   ],
            // },
            // {
            //   label: "年龄",
            //   type: "input",
            //   prop: "age",
            //   data: [],
            // },
            // {
            //   label: "工龄",
            //   type: "input",
            //   prop: "workAge",
            //   data: [],
            // },
            // {
            //   label: "民族",
            //   type: "input",
            //   prop: "nationality"
            // },
            // {
            //   label: "政治面貌",
            //   type: "select",
            //   prop: "politicalStatus",
            //   data: this.$utils.getCacheStatus("sysUser.politicalStatus"),
            // },
            // {
            //   label: "生日",
            //   type: "datePicker",
            //   prop: "birthday",
            //   data: [],
            // },
            // {
            //   label: "学历",
            //   type: "select",
            //   prop: "education",
            //   data: this.$utils.getCacheStatus("sysUser.education"),
            // },
            // {
            //   label: "婚姻状况",
            //   type: "select",
            //   prop: "maritalStatus",
            //   data: this.$utils.getCacheStatus("sysUser.maritalStatus"),
            // },
            // {
            //   label: "职位",
            //   type: "input",
            //   prop: "position",
            //   data: [],
            // },

          ], // 表单label
          options: {
            labelWidth: "130px"
          },
          url: api.system.otherUser
        },
        // 添加字段
        // editColumns: {
        //   labelWidth: "120px",
        //   span: 12,
        //   columns: [
        //     {
        //       label: "员工姓名",
        //       type: "input",
        //       prop: "name",
        //       rule: [
        //         {required: true, message: "请输入用户名", trigger: "blur"},
        //         {
        //           min: 2,
        //           max: 15,
        //           message: "长度在 2 到 15 个字符",
        //           trigger: "blur"
        //         }
        //       ]
        //     },
        //     {
        //       label: "门店名称",
        //       type: "select",
        //       prop: "storeId",
        //       data: [],
        //       url: api.system.seStore,
        //     },
        //     {
        //       label: "登陆账号",
        //       type: "input",
        //       prop: "loginName",
        //       disabled: true
        //     },
        //     {
        //       label: "角色",
        //       type: "select",
        //       prop: "roleId",
        //       span: 12,
        //       data: [],
        //       url: api.system.roleOther,
        //       rule: [
        //         {required: true, message: "请选择角色", trigger: "blur"},
        //       ],
        //     },
        //     {
        //       label: "手机号",
        //       type: "input",
        //       prop: "phone",
        //       maxLength: 11,
        //       rule: [
        //         {required: true, message: "请输入手机号", trigger: "blur"},
        //         {pattern: this.$utils.reg.phone, message: "请输入正确的手机号", trigger: 'blur'}
        //       ],
        //     }, {
        //       label: "邮箱",
        //       type: "input",
        //       prop: "email",
        //
        //       rule: [
        //         {required: true, message: "请输入邮箱", trigger: "blur"},
        //         {pattern: this.$utils.reg.email, message: "请输入正确的邮箱", trigger: 'blur'}
        //       ]
        //     },
        //     {
        //       label: "籍贯",
        //       type: "input",
        //       prop: "nativePlace",
        //     },
        //     {
        //       label: "性别",
        //       type: "select",
        //       prop: "gender",
        //       data: this.$utils.getCacheStatus("sysUser.gender"),
        //       defaultIndex: 0,
        //       rule: [
        //         {required: true, message: "请选择性别", trigger: "blur"},
        //       ],
        //     },
        //     {
        //       label: "年龄",
        //       type: "input",
        //       prop: "age",
        //       data: [],
        //     },
        //     {
        //       label: "工龄",
        //       type: "input",
        //       prop: "workAge",
        //       data: [],
        //     },
        //     {
        //       label: "民族",
        //       type: "input",
        //       prop: "nationality"
        //     },
        //     {
        //       label: "政治面貌",
        //       type: "select",
        //       prop: "politicalStatus",
        //       data: this.$utils.getCacheStatus("sysUser.politicalStatus"),
        //     },
        //     {
        //       label: "生日",
        //       type: "datePicker",
        //       prop: "birthday",
        //       data: [],
        //     },
        //     {
        //       label: "学历",
        //       type: "select",
        //       prop: "education",
        //       data: this.$utils.getCacheStatus("sysUser.education"),
        //     },
        //     {
        //       label: "婚姻状况",
        //       type: "select",
        //       prop: "maritalStatus",
        //       data: this.$utils.getCacheStatus("sysUser.maritalStatus"),
        //     },
        //     {
        //       label: "职位",
        //       type: "input",
        //       prop: "position",
        //       data: [],
        //     },
        //
        //   ], // 表单label
        //   options: {
        //     labelWidth: "130px"
        //   },
        //   url: api.system.otherUser
        // },
        //修改密码
        changePwdDialog: {
          formType: "other",
          labelWidth: "100px",
          span: 12,
          columns: [
            {
              label: "员工姓名",
              type: "input",
              prop: "name",
              disabled: true
            },
            {
              label: "登录用户名",
              type: "input",
              prop: "loginName",
              disabled: true
            },
            {
              label: "新密码",
              type: "password",
              prop: "newPasswordPlaintext",
              rule: [
                {required: true, message: "请输入密码", trigger: "blur"},
                {
                  min: 6,
                  max: 20,
                  message: "长度在6到 20个字符",
                  trigger: "blur"
                }
              ]
            },
            {
              label: "确认密码",
              type: "repassword",
              prop: "rePassword",
              passwordProp: "newPasswordPlaintext",
            }
          ],
          url: api.system.account,
          formData: {},
        },
      };
    },
    created() {
      this.setStore(this.searchOptions.simple);
      this.storeMethod();
    },
    methods: {
      storeMethod() {
        let userInfo = this.$utils.getSysUser();
        if (userInfo.storeId) {
          let storeId = this.addColumns.columns.filter((item) => item.prop === "storeId")[0];
          storeId.disabled = true;
          storeId.defaultValue = userInfo.storeId;
          this.storeChange({storeId: userInfo.storeId});
        }
      },
      storeChange(row) {
        this.$axios.fetchPost(api.system.roleOther + '/list', {storeId: row.storeId}).then(data => {
          if (data.code === 200) {
            this.addColumns.columns.filter(item => item.prop === 'roleId')[0].data = data.data;
          } else {
            this.$message({message: '请求失败', type: 'error'})
          }
        })
      },
      updatePassword(row) {
        this.changePwdDialog.formData = row;
        this.$nextTick(() => {
          this.addColumns && this.$store.commit(this.$utils.storeKeys.OTHERFORM, this.changePwdDialog);
          this.$refs['addFormOptions'].setFormOptions('other', row.id, '修改密码');
        })
      },
      upgradePwd(data) {
        let params = {id: data.id, newPassword: data.newPassword};
        this.$axios.fetchPost(api.system.account + "/password" + `?${this.$utils.JSONToString(params)}`, {}).then(result => {
          if (result.code === 200) {
            this.$notify({
              type: "success",
              title: '修改操作',
              message: '成功',
              showClose: false,
            });
            // this.$message({type: 'success', message: '修改成功!'});
          } else {
            this.$message({type: 'error', message: result.msg});
          }
        }).catch(err => {
          this.$notify({
            type: "error",
            title: '修改操作',
            message: '失败',
            showClose: false,
          });
          // this.$message({type: 'error', message: '修改失败!'});
        })
      }

  }
};
</script>




// WEBPACK FOOTER //
// src/page/system/user/other/Mgmt.vue